import PrepressSortTable from "./PrepressSortTable";
import PrepressPublicationJobsIndex from "./PrepressPublicationJobsIndex";

class PrepressPublicationJobsSortTable extends PrepressSortTable {
  reactTableComponent() {
    return PrepressPublicationJobsIndex;
  }

  showInHouse(providers) {
    const show = [];
    this.data.forEach((pub) => {
      if (providers.includes(pub.print_provider)) {
        show.push(pub);
      }
    });
    return this.getReverseList() ? show.slice().reverse() : show;
  }

  showOutSourced() {
    const show = [];
    const providers = this.inHouseWilmingtonProvider() + this.inHouseDallasProvider();
    this.data.forEach((pub) => {
      if (providers.includes(pub.print_provider) === false) {
        show.push(pub);
      }
    });
    return this.getReverseList() ? show.slice().reverse() : show;
  }
}

export default PrepressPublicationJobsSortTable;
